import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgDragVertical = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M8.778 18.036h-.064m.05.259a.26.26 0 1 1 0-.522.26.26 0 0 1 0 .522M8.778 12.012h-.064m.05.26a.26.26 0 1 1 0-.522.26.26 0 0 1 0 .522M8.778 5.993h-.064m.05.259a.26.26 0 1 1 0-.522.26.26 0 0 1 0 .522M15.25 18.036h-.065m.05.259a.26.26 0 1 1 0-.522.26.26 0 0 1 0 .522M15.25 12.012h-.065m.05.26a.26.26 0 1 1 0-.522.26.26 0 0 1 0 .522M15.25 5.993h-.065m.05.259a.26.26 0 1 1 0-.522.26.26 0 0 1 0 .522"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgDragVertical);
export default ForwardRef;
